import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class SaveIndicesUseCase extends BaseUseCase {
    constructor(repo) {
        super();
        this.repo = repo;
    }
    async fetchResult(req) {
        return await this.repo.saveIndicesData(req);
    }
}
export default SaveIndicesUseCase;
